import React from 'react';
import './PricingSection.css';
import SolidityChart from './speedometer';
import { FiAward, FiCheck, FiMonitor, FiShield, FiTool, FiWifi, FiZap } from 'react-icons/fi';

const sendMessage = (plan) => {
  const speedText = `${plan.displaySpeed} ${plan.speedLabel}`.trim();
  const message = `Olá! Tenho interesse no plano ${plan.title} (${speedText}). Poderia me passar mais informações?`;
  const encodedMessage = encodeURIComponent(message);
  const url = `https://wa.me/31990870412?text=${encodedMessage}`;
  window.open(url, '_blank');
};

const iconMap = {
  fiber: FiZap,
  support: FiTool,
  screens: FiMonitor,
  wifi: FiWifi,
  shield: FiShield,
  tool: FiTool,
  award: FiAward,
};

const plans = [
  {
    title: 'Essencial',
    speed: 400,
    displaySpeed: '400',
    speedLabel: 'Mega',
    price: '99,90',
    color1: '#00c360',
    color2: '#9cf5c6',
    tag: 'Entrada inteligente',
    features: [
      { icon: 'fiber', text: 'Fibra óptica pura' },
      { icon: 'support', text: 'Suporte local ágil' },
    ],
    recommendation: 'Ideal para redes sociais, e-mails, aulas online e streaming em HD.',
  },
  {
    title: 'Avançado',
    speed: 600,
    displaySpeed: '600',
    speedLabel: 'Mega',
    price: '109,90',
    color1: '#00c360',
    color2: '#9cf5c6',
    tag: 'Mais escolhido',
    features: [
      { icon: 'fiber', text: 'Fibra óptica pura' },
      { icon: 'screens', text: 'Ideal para 4K e múltiplas telas' },
      { icon: 'support', text: 'Suporte local ágil' },
    ],
    recommendation: 'Perfeito para home office, vários dispositivos e streaming em Full HD/4K.',
  },
  {
    title: 'Gamer/Pro',
    speed: 800,
    displaySpeed: '800',
    speedLabel: 'Mega',
    price: '129,90',
    color1: '#00c360',
    color2: '#f3d36a',
    principal: true,
    tag: 'Performance premium',
    features: [
      { icon: 'fiber', text: 'Fibra óptica pura' },
      { icon: 'wifi', text: 'Wi-Fi 6 incluso' },
      { icon: 'shield', text: 'Ultra estabilidade e baixa latência' },
      { icon: 'support', text: 'Suporte local ágil' },
    ],
    recommendation: 'Recomendado para gamers, streaming em 4K e famílias conectadas.',
  },
  {
    title: 'Infinity',
    speed: 1000,
    displaySpeed: 'Ilimitado',
    speedLabel: '',
    price: '169,90',
    color1: '#00c360',
    color2: '#9cf5c6',
    tag: 'Máxima velocidade',
    features: [
      { icon: 'fiber', text: 'Fibra óptica pura' },
      { icon: 'wifi', text: 'Wi-Fi 6 e rede Mesh incluída' },
      { icon: 'award', text: 'Atendimento VIP' },
      { icon: 'tool', text: 'Instalação prioritária' },
    ],
    recommendation: 'Velocidade máxima para downloads, jogos e múltiplos streamings em 4K.',
  },
];

function PricingSection() {
  return (
    <section id="plans" className="pricing-section">
      <div className="section-header">
        <span className="section-kicker">Planos VitaLink</span>
        <h2>Escolha o plano ideal para sua casa ou empresa</h2>
        <p>
          Fibra óptica pura, instalação organizada e atendimento local para você
          contratar com segurança desde o primeiro contato.
        </p>
      </div>

      <div className="pricing-cards">
        {plans.map((plan) => (
          <article
            key={plan.title}
            className={`pricing-card ${plan.principal ? 'principal-plan' : ''}`}
          >
            <div className="plan-heading">
              <span>{plan.tag}</span>
              <h3>{plan.title}</h3>
            </div>

            <div className="speed-gauge">
              <SolidityChart value={plan.speed} color1={plan.color1} color2={plan.color2} />
              <div className={`speed-block ${!plan.speedLabel ? 'speed-unlimited' : ''}`}>
                <strong>{plan.displaySpeed}</strong>
                {plan.speedLabel && <span>{plan.speedLabel}</span>}
              </div>
            </div>

            <p className="card-price">
              <span>R$</span> {plan.price}
              <small>/mês</small>
            </p>

            <ul className="card-features">
              {plan.features.map((feature) => {
                const Icon = iconMap[feature.icon] || FiCheck;
                return (
                  <li key={feature.text}>
                    <Icon />
                    <span>{feature.text}</span>
                  </li>
                );
              })}
            </ul>

            <p className="card-recommendation">{plan.recommendation}</p>

            <button className="card-button" onClick={() => sendMessage(plan)}>
              Assine já
            </button>
          </article>
        ))}
      </div>
    </section>
  );
}

export default PricingSection;
